export const markGroupsofItemsInPlaylist = ({ playlist, items }) => {
  const clonedItems = JSON.parse(JSON.stringify(items))

  if (playlist?.length > 0) {
    clonedItems.forEach((category) => {
      category.items.forEach((session) => {
        session.isInPlaylist = !!playlist.find((playlistItem) => {
          return playlistItem.cmsId === session?.contentUUID
        })
      })
    })
  }

  return clonedItems
}

export const markItemsInPlaylist = ({ playlist, items }) => {
  if (!items) return []
  const clonedItems = JSON.parse(JSON.stringify(items))
  if (playlist?.length > 0) {
    clonedItems.forEach((item) => {
      item.isInPlaylist = !!playlist.find((playlistItem) => {
        return playlistItem.cmsId === item?.contentUUID || playlistItem.cmsId === item?.item?.contentUUID
      })
    })
  }

  return clonedItems
}

export const getPromosFromContentIDs = ({ playlistItems, promos }) => {
  const foundValidContent = promos?.filter((promo) => {
    return playlistItems.find((item2) => {
      return item2.cmsId === promo.contentUUID
    })
  })
  return foundValidContent
}

export const getPlaylistSectionByType = ({ playlist, type, queryResultSet }) => {
  const foundPlaylistItems = playlist?.filter((item) => {
    return item.type === type
  })

  const foundValidContent = getPromosFromContentIDs({
    playlistItems: foundPlaylistItems,
    promos: queryResultSet,
  })

  return markItemsInPlaylist({ playlist, items: foundValidContent })
}
